import { CareerStage } from '@/types/onboarding';

// Simple static career stage determination based on years of experience
export function determineCareerStage(formData: any): CareerStage {
  const yearsExp = parseInt(formData?.basicInfo?.experience || '0');
  
  if (yearsExp < 2) return CareerStage.Entry;
  if (yearsExp < 5) return CareerStage.Mid;
  if (yearsExp < 8) return CareerStage.Senior;
  return CareerStage.Transition;
}

// Static career path generation
export function generateStaticLearningPath(stage: CareerStage) {
  const paths = {
    [CareerStage.Entry]: {
      title: 'Foundation Builder',
      description: 'Build core skills and knowledge',
      milestones: [
        'Learn fundamental concepts',
        'Complete basic projects',
        'Build portfolio'
      ]
    },
    [CareerStage.Mid]: {
      title: 'Skill Enhancer',
      description: 'Deepen expertise and specialization',
      milestones: [
        'Master advanced concepts',
        'Lead small projects',
        'Mentor beginners'
      ]
    },
    [CareerStage.Senior]: {
      title: 'Leadership Track',
      description: 'Develop leadership and strategic skills',
      milestones: [
        'Lead major projects',
        'Mentor teams',
        'Drive technical decisions'
      ]
    },
    [CareerStage.Transition]: {
      title: 'Career Transformer',
      description: 'Navigate career change successfully',
      milestones: [
        'Build transferable skills',
        'Network in new industry',
        'Gain relevant certifications'
      ]
    }
  };

  return paths[stage] || paths[CareerStage.Entry];
}

// Calculate progress percentage
export function calculateProgress(currentStage: CareerStage): number {
  const stages = [CareerStage.Entry, CareerStage.Mid, CareerStage.Senior, CareerStage.Transition];
  const currentIndex = stages.indexOf(currentStage);
  return Math.round(((currentIndex + 1) / stages.length) * 100);
} 